const t = {
  name: "ChevronLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.4141 5.00015L9.41406 12.0002L16.4141 19.0002L14.9998 20.4144L6.58564 12.0002L14.9998 3.58594L16.4141 5.00015Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronLeft
};
